export default "__VITE_ASSET__B$vPo4DQ__"